export const loadingstyle = `
input.dcDisplayAlways {
    display: inline-block!important;
}

.dcloading{
    font-size:0;
    width:15px;
    height:15px;
    border-radius:15px;
    padding:0;
    border:2px solid #FFFFFF;
    border-bottom:2px solid rgba(255,255,255,0.0);
    border-left:2px solid rgba(255,255,255,0.0);
    background-color:transparent !important;
    animation: rotateAnimation infinite linear 0.5s;
    -webkit-animation: wk-rotateAnimation infinite linear 0.5s;
    position: absolute;
    left: 0;
    right: 0;
    top: calc(50% - 7.5px);
    margin: 0 auto;
    opacity: 0;
    transition: opacity 300ms ease;
}

.loading-dark {
    opacity: 1!important;
    border-color: #565656;
    border-bottom: 2px solid rgba(255,255,255,0.0);
    border-left: 2px solid rgba(255,255,255,0.0);
}

.loading-wrapper {
    position: relative;
    height: 10px;
    width: 20px;
    display: inline-block;
}

#dcodeSubmit {
    position: relative;
    outline: 0;
}

button#dcodeSubmit:disabled {
    background-color: #d4d4d4;
}

#dcodeInput {
    -webkit-user-select: auto!important;
    -moz-user-select: auto!important;
    -ms-user-select: auto!important;
    -o-user-select: auto!important;
    user-select: auto!important;
    -webkit-appearance: unset;
    -moz-appearance: unset;
    cursor: auto!important;
}

.dcodeInput, .dcodeButton {
    display: inline-block!important;
}

#dcodeButtonLabelPlaceholder {
    opacity: 0;
}

#dcodeButtonLabel {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    transition: opacity 300ms ease;
}

@keyframes rotateAnimation {
    0%   {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
@-webkit-keyframes wk-rotateAnimation {
    0%   {-webkit-transform: rotate(0deg);}
    100% {-webkit-transform: rotate(360deg);}
}

.dc_smooth, .dcSmooth {
    transition: all 200ms ease;
}

.dcodeLineThrough {
    text-decoration: line-through;
}

.dcodeAbsoluteTransparent {
    position: absolute!important;
    opacity: 0!important;
}

/* Discount box style */

.dc-clearfix-100 {
    width: 100%;
}

.dcInvalidCode {
    border-color: #e32c2b!important;
    border-width: 2px;
}

p.dcodeErrorMessage {
    color: #e32c2b;
    margin: 0;
}

#dcodeInfo {
    margin-top: 20px;
    /*width: 100%;
    display: grid;
    justify-items: right;*/
}

.dcDiscountBox {
    background-color: rgba(113, 113, 113, 0.11);
    display: inline-block;
    padding: 7px 12px 7px 12px;
    margin-bottom: 20px;
}

.dcIcon svg {
    color: rgb(113, 113, 113);
    fill: currentcolor;
}

.dcIcon {
    width: 18px;
    height: 18px;
    transform: translateY(3px);
}

.dcDiscountBox p {
    display: inline;
    padding-left: 6px;
}

.dcodeTable {
    border: 0px solid transparent;
    /*width: 100%;*/
    background-color: transparent;
    max-width: 300px;
    display: inline;
}

.dcodeTable td {
    padding: 10px 0px 10px 45px;
    text-align: right;
    border: 0px solid transparent;
}

.dcodeTable td:first-child {
    padding: 10px 0px;
    text-align: left;
}

.dcodeTotal td {
    text-align: right;
    font-size: 115%;
    padding: 10px 0px 10px 20px;
}

.dcodeTotal td:first-child {
    padding: 20px 0px;
    text-align: left;
}

.dcRestriction {
    opacity: 0.5;
}

#crossSVG {
    stroke: rgba(113,113,113,0.9);
    width: 12px;
    height: 12px;
}

#removeDiscount {
    background: none;
    border: none;
    padding: 0;
    margin: 0 0 0 5px;
    display: inline-block!important;
    width: auto!important;
    min-width: unset!important;
    height: auto!important;
    min-height: unset!important;
    vertical-align: middle!important;
}

#dcHiddenDiscountFrame {
    height: 1px;
    width: 1px;
    opacity: 0;
    position: absolute;
    left: -999px;
}

/* Wizard */
.dcodeSelected {
    background: unset;
    background-color: #cee2ff!important;
}
.dcodeHover {
    background: unset;
    background-color: #ebf3ff;
}

.dcRestriction {
  display: none;
}

.dcInline {
  display: inline;
}
`;
